// extracted by mini-css-extract-plugin
export default {"cardsBlock":"CardsBlock_cardsBlock__WEDZP","nothing":"CardsBlock_nothing__Z0JE1"};